import { render, staticRenderFns } from "./fileSelector.vue?vue&type=template&id=b12047b4"
import script from "./fileSelector.vue?vue&type=script&lang=js"
export * from "./fileSelector.vue?vue&type=script&lang=js"
import style0 from "./fileSelector.vue?vue&type=style&index=0&id=b12047b4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./fileSelector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports